<template>
  <div class="ibox checkItemMng">
    <div class="ibox-content">
      <div class="flex-row flex-nowrap">
        <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs">
          <el-button type="primary" name="create" @click="handleCreate" :disabled="options.selection.length">新增</el-button>
          <el-button type="primary" @click="handleEditRow" :disabled="options.selection.length!=1">编辑</el-button>
          <el-button type="primary" @click="handleDeleteRow" :disabled="options.selection.length==0">删除</el-button>
        </div>
      </div>

      <div class="dept-mng-table no-border">
        <r-table
          :ref="tableVarity"
          :dataSource="tableData"
          :options="options"
          row-key="id"
          default-expand-all
          :tree-props="{children:'children',hasChildren:'hasChildren'}"
          :show-pagination="false"
          @row-click="handleRowClick"
          @select-all="handleSelectAll"
        >
          <el-table-column prop="name" label="检查项" class-name="dept-column" align="center">
            <template #header>
              <div class="nameHeaderDiv" >
                <div class="typeHeaderDiv" >
                  <el-input
                    placeholder="检查类型"
                    v-model="filters.search.itemBelong"
                    @change="handleSearch()"
                  >
                  </el-input>
                </div>
                <div class="cntHeaderDiv" >
                  <el-input
                    placeholder="检查内容"
                    v-model="filters.search.name"
                    @change="handleSearch()"
                  >
                  </el-input>
                </div>
              </div>
            </template>
            <template #default="scope">
              <el-tooltip :content="scope.row.name" placement="top">
              <div v-if="scope.row.itemBelong" class="typeDiv" >{{scope.row.name}}</div>
              <div v-else  class="cntDiv">{{scope.row.name}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="启用/禁用" width="200" align="center">
            <template #default="scope">
              <el-switch
                v-model="itemStatus[scope.row.id]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="handleStatusChange(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </r-table>
      </div>
    </div>
    <Modal :modalTitle="clickModalType" modalId="checkItemModal" @show="modalShow = true" @hide="modalShow = false" modalSize="modal-lg">
      <manageForm
        :formType="clickModalType"
        :longItemList="longItemList"
        :dept="selectDept"
        :modalShow="modalShow"
        :oper-type="operType"
        @success="submitSuccess"
        :isFill="isFill"
      ></manageForm>
    </Modal>
  </div>
</template>
<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import DeptItem from './item'
import manageForm from './manageForm'

import { mapActions } from 'vuex'

export default {
  name: 'SystemDept',
  components: {
    manageForm,
    RModal,
    RTable,
  },
  mixins: [ tableMix],
  data() {
    return {
      tableVarity: 'system-dept-mng-table',
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 500
      },

      clickModalType: 'new',
      clickModalContent: '新建部门',
      tableData: [],
      selectDept: null,
      loading: false,
      didInvalidate: false,
      modalShow: false,
      longItemList: [],
      headerID: 0,
      maxHeight: null,
      isFill: false, // 二级部门是否必填
      itemStatus:{},
      filters:{
        search:{
          itemBelong:'',
          name:'',
        }
      }
    }
  },
  created() {
    //判断是否需要获取数据
    this.getQuery({})
  },
  mounted() {
    this.maxHeight = $('body').height() - $('.checkItemMng').offset().top - 140
    $('.tree-container').css('maxHeight', this.maxHeight + 'px')
  },
  methods: {
    ...mapActions(['alertToggle']),
    handleSearch(){
      this.getQuery({...this.filters.search})
    },
    getQuery(params) {
      let url = 'ROOM.CHECKTASK_ITEM_LIST'
      const _this = this
      this.fetchData({
        url,
        method: 'get',
        params:{params:JSON.stringify(params)},
      })
        .then((res) => {
          _this.longItemList = res.itemBelongList
          let tableData = []

          res.data.map((item,key)=>{
            tableData.push({id:'ii_'+key,name:item.itemBelong,status:item.itemBelongStatus,children:item.checkSubResult})
            this.itemStatus['ii_'+key] = item.itemBelongStatus
            item.checkSubResult.map((sItem)=>{
              this.itemStatus[sItem.id] = sItem.status
            })
          })
          _this.tableData = tableData || []

          this.isFill = res.isFill
        })
        .catch((err) => {
          _this.error = err
        })
    },
    _reloadData() {
      //强制请求数据
      this.filters.search.name = ''
      this.getQuery({})
    },
    handleDetail(row) {
      this.clickModalType = '详情'
      this.operType = 'show'
      this.selectDept = row
      $('#checkItemModal').modal('toggle')
    },
    handleEditRow(type, row) {
      if (this.options.selection.length === 1) {
        this.edit(this.options.selection[0])
      } else {
        this.alertToggle({
          alertType: 'danger',
          alertContent: '仅支持单条数据编辑！',
        })
      }
    },
    handleDeleteRow() {
      let ids = []
      let typeIds = []
      this.options.selection.map((row)=>{
        if((row.id+'').indexOf('ii_')>-1){
          typeIds.push(row.name)
        }else{
          ids.push(row.id)
        }
      })
      let tipMsg = typeIds.length ? '删除检查类型将同步删除该类型检查内容，确认删除？':'确定删除当前选中的信息吗？'
      this.$confirm(tipMsg, { type: 'warning' })
        .then(() => {
          this.doDelete(typeIds,ids)
        })
        .catch(() => false)
    },
    doDelete(typeIds,ids){
      typeIds.map((typeInfo)=>{
        this.fetchData({
          url:'ROOM.CHECKTASK_ITEM_TITLE_DELETE',
          method: 'get',
          params:{params : JSON.stringify({itemBelong:typeInfo})},
        })
      })

      this.fetchData({
        url:'ROOM.CHECKTASK_ITEM_DELETE',
        method: 'get',
        params:{params : JSON.stringify({ids:ids.join(',')})},
      }).then((res) => {
        this.$message.success('操作成功！')
        this._reloadData()
      }).catch((err) => {
        this.alertToggle({
          alertType: 'danger',
          alertContent: err,
        })
      })
    },
    handleCreate() {
      this.clickModalType = '新增'
      this.operType = 'create'

      this.selectDept = {
        itemBelong:'',
        name:'',
        status:1,
        id:'',
        itemBelongRadio:1,
        itemBelong1: '',
        itemBelong2: '',
      }
      $('#checkItemModal').modal('toggle')
    },
    append(store, data) {
      this.clickModalType = '新建'
      this.selectDept = {
        pId: data.id,
        deptName: '',
        remark: '',
      }
      $('#checkItemModal').modal('toggle')
    },
    edit(data) {
      this.clickModalType = '编辑'
      this.operType = 'edit'
      this.selectDept = {
        ...data,
        itemBelongRadio:1,
        itemBelong1: data.itemBelong,
        itemBelong2: '',
      }
      $('#checkItemModal').modal('toggle')
    },
    submitSuccess() {
      //this.submitFilter()
      $('#checkItemModal').modal('hide')
      this._reloadData()
    },
    handleSelectAll(selection){
      //全选
      if(selection.length && selection[0].id==this.tableData[0].id){
        selection.map((item)=>{
          item.children.map((row)=>{
            this.$refs[this.tableVarity].$refs.table.toggleRowSelection(row,true)
          })
        })
      }else{  //反选
        this.tableData.map((item)=>{
          item.children && item.children.map((row)=>{
            this.$refs[this.tableVarity].$refs.table.toggleRowSelection(row,false)
          })
        })
      }

    },
    //修改状态
    handleStatusChange(row,change){
      let type = 'item'
      let url = 'ROOM.CHECKTASK_ITEM_SAVE';
      let formParams = {...row}

      if((row.id+'').indexOf('ii_')>-1){
        type = 'title'
        url = 'ROOM.CHECKTASK_ITEM_TITLE_STATUS'
        formParams = {"itemBelong":row.name,"itemBelongStatus":this.itemStatus[row.id]}
      }else{
        formParams = {id:row.id,"itemBelong":row.itemBelong,"name":row.name,"note":row.note,"status":this.itemStatus[row.id]}
      }

      let params = {
        params : JSON.stringify(formParams)
      }
      this.fetchData({
        url,
        method: 'get',
        params,
        isLoading: false
      }).then(res => {
        this.$message.success('操作成功！')
        this._reloadData()
      }).catch(err => {
        console.log(err)
      })
    },
    renderContent(h, { node, data, store }) {
      return (
        <DeptItem
          data={data}
          appendClick={() => this.append(store, data)}
          removeClick={() => this.remove(store, data)}
          editClick={() => this.edit(store, data, node)}
        />
      )
    },
  },
}
</script>
<style lang="less" scoped>
  .checkItemMng .el-tree {
    border: 0;
  }
  .create-dept-btn {
    width: 200px;
    margin: 30px auto;
  }
  .checkItemMng {
    .tree-container {
      overflow-y: scroll;
    }
    .dept-item {
      font-size: @font-small;
    }
  }
  .dept-mng-table {
    /deep/ .dept-column .cell {
      text-align: left;
      display: flex;
    }
    /deep/ .el-table__expand-icon {
      color: white;
    }
  }
  #checkItemModal{
    padding-top: 100px;
  }
</style>
<style lang="less" scoped>
  .nameHeaderDiv{
    display: flex;
    width: 100%;
  }
  .typeHeaderDiv{
    width: 500px;
    text-align: center;
    padding: 0 20px;
  }
  .cntHeaderDiv{
    flex:1;
  }
  .typeDiv{
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: nowrap;
    cursor: pointer;
    margin-left: 500px;

  }
  .cntDiv{
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: nowrap;
    cursor: pointer;
    max-width: 500px;
    padding-right: 30px;
  }

</style>
